import Select from 'react-select';
import {useState, useEffect} from "react";


const SearchableDropdown = (props) => {

    const [isFocused, setIsFocused] = useState(false);
    const [selectedValue, setSelectedValue] = useState(props.value);

    const options = props.dataset.data.map(item => ({
        value: item[props.dataset.value],
        label: props?.occupancyCheck
            ? !item?.max_occupancy || (item?.number_residents && item?.number_residents >= item?.max_occupancy)
                ? item[props.dataset.label] + " (Room Full)"
                : item?.devices && item?.devices?.length > 0
                    ? item[props.dataset.label] + " (NO DEVICES)"
                    : item[props.dataset.label]
            : item[props.dataset.label],
        isDisabled: props?.occupancyCheck
            ? !item?.max_occupancy || (item?.number_residents && item?.number_residents >= item?.max_occupancy)
            : false
    }));

    useEffect(() => {
        if (props?.value === '' || props?.value === 0) {
            setSelectedValue(null);
        }else{
            for (let i=0; i < options.length; i++){
                if (options[i].value === props?.value){
                    setSelectedValue(options[i]);
                    break;
                }
            }
        }
    }, [props?.value, props.dataset.data]);

    // Call formCheck when selectedValue changes
    useEffect(() => {
        if (props.formCheck) {
            props.formCheck();
        }
    }, [selectedValue]);

    const customStyles = {
        control: (base, state) => ({...base, minHeight: '38px', height: props?.height ? props.height : "unset",
            borderColor: props?.required ? state.hasValue ? '#00d97e' : '#dc3545' : '#A8A8A8', borderWidth: '1px',
            // boxShadow: state.hasValue ? '0 0 0 0.25rem rgba(25, 135, 84, 0.25)' : '0 0 0 0.25rem rgba(220, 53, 69, 0.25)',
            '&:hover': {
                borderColor: props?.required ? state.hasValue ? '#00d97e' : '#dc3545' : '#A8A8A8'
            },
            '&:focus-within': {
                borderColor: props?.required ? state.hasValue ? '#00d97e' : '#dc3545' : '#A8A8A8',
                // boxShadow: state.hasValue ? '0 0 0 0.25rem rgba(25, 135, 84, 0.25)' : '0 0 0 0.25rem rgba(220, 53, 69, 0.25)'
            }
        }),
        option: (base, state) => ({...base,
            backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : 'white',
            color: state.isDisabled ? '#6c757d' : state.isSelected ? 'white' : '#212529',
            cursor: state.isDisabled ? 'not-allowed' : 'default',
            '&:hover': {
                backgroundColor: state.isDisabled ? 'white' : state.isSelected ? '#0d6efd' : '#e9ecef'
            }
        }),
        menu: (base) => ({...base, zIndex: 9999}),
        singleValue: (base) => ({...base, color: '#212529'}),
        placeholder: (base) => ({...base, color: 'transparent'})
    };

    return (
        <>
            <div className={`my-1 position-relative ${props?.divClass ? props?.divClass : ""}`}
                 id={props.id+"-div"}>
                <div style={{
                    position: 'absolute',
                    top: (isFocused || selectedValue) ? '-10px' : '8px',
                    left: '12px',
                    backgroundColor: 'white',
                    padding: '0 5px',
                    transition: 'all 0.2s ease',
                    zIndex: 1,
                    fontSize: (isFocused || selectedValue) ? '0.875rem' : '1rem',
                    color: props?.required ? props.value ? 'rgba(var(--bs-body-color-rgb), 0.65)' : '#dc3545' : '#A8A8A8'
                }}>
                    {props.label_name}
                </div>
                <Select
                    id={props.id}
                    options={options}
                    styles={customStyles}
                    placeholder=" "
                    isClearable={props?.clearable}
                    isSearchable
                    className="basic-single"
                    classNamePrefix="select"
                    required={props?.required}
                    aria-required="true"
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    onChange={(value) => {
                        props.onChange(value?.value)
                        setSelectedValue(value)
                    }}
                    value={selectedValue}
                />
            </div>
        </>
    );
};

export default SearchableDropdown;